import RichTextToolbarRegistry from './RichTextToolbarRegistry';
import HotkeyRegistry from './HotkeyRegistry';

export {
    RichTextToolbarRegistry,
    HotkeyRegistry
};
